import { render, staticRenderFns } from "./loginFront.vue?vue&type=template&id=869f04f4&scoped=true"
import script from "./loginFront.vue?vue&type=script&lang=js"
export * from "./loginFront.vue?vue&type=script&lang=js"
import style0 from "./loginFront.vue?vue&type=style&index=0&id=869f04f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869f04f4",
  null
  
)

export default component.exports